module.exports = __webpack_public_path__ + "assets/img/step-4-833f0088.png";